import {EzAppLayout, EzThemeProvider} from '@ezcater/recipe';
import Routes from './Routes';
import ErrorBoundary from './components/ErrorBoundary';
import {AssignmentsProvider} from './services/eppo';
import theme from './theme';
import './i18n';

const App = () => (
  <EzThemeProvider theme={theme}>
    <EzAppLayout>
      <ErrorBoundary>
        <AssignmentsProvider>
          <Routes />
        </AssignmentsProvider>
      </ErrorBoundary>
    </EzAppLayout>
  </EzThemeProvider>
);

export default App;
